import type { ReactNode } from 'react';

type Props = {
    title: ReactNode;
    headerActions?: ReactNode;
    actions: ReactNode;
    children: ReactNode;
};

export const CreditFormCard: React.FC<Props> = ({ actions, children, headerActions, title }) => (
    <div className="flex flex-col gap-3 rounded-md border border-grey-outline-light bg-surface-light p-3 text-left whitespace-normal">
        <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-bold text-midnight">{title}</p>
            {headerActions}
        </div>
        {children}
        <div className="flex justify-end gap-2">{actions}</div>
    </div>
);
